class widerrufManuell extends HTMLElement {
  connectedCallback() {
    this.toggleManuelleEingabe();
  }

  toggleManuelleEingabe() {
    const fieldset = this.querySelector(".manuelle-eingabe");
    this.querySelectorAll('input[name="positionAuswahl"]').forEach((radio) => {
      radio.addEventListener("change", () => {
        fieldset.disabled =
          this.querySelector('input[name="positionAuswahl"]:checked').value !== "manuell";
      });
    });
  }
}

if (!customElements.get("widerruf-manuell")) {
  customElements.define("widerruf-manuell", widerrufManuell);
}
